import { IconChevronDown } from "@tabler/icons-react";
import { useState } from "react";
import type { DescarteZip } from "@/features/cargar-zip/types";
import { Badge, Group, Stack, Text } from "@/components/ui";
import { cn } from "@/lib/cn";

/**
 * Disclosure colapsable con la lista de descartes (archivos del ZIP que
 * no entraron al procesamiento por motivos F1/F2/F4/J/K). Reemplaza el
 * `<Accordion>` de Mantine (sin equivalente en `components/ui/` · un solo
 * ítem no justifica un átomo genérico, se resuelve con `useState` a mano).
 */
export function DescartesAccordion({ descartes }: { descartes: DescarteZip[] }) {
  const [abierto, setAbierto] = useState(false);
  if (descartes.length === 0) return null;
  return (
    <div className="rounded-md border border-border">
      <button type="button" onClick={() => setAbierto((a) => !a)} className="flex w-full items-center justify-between px-3 py-2.5">
        <Group gap="xs">
          <Text size="sm" fw={500}>
            Ver descartes
          </Text>
          <Badge color="slate" variant="light">
            {descartes.length}
          </Badge>
        </Group>
        <IconChevronDown size={16} className={cn("text-muted-foreground transition-transform", abierto && "rotate-180")} />
      </button>
      {abierto && (
        <div className="border-t border-border px-3 py-2.5">
          <Stack gap={6}>
            {descartes.map((d, i) => (
              <DescarteItem key={i} descarte={d} />
            ))}
          </Stack>
        </div>
      )}
    </div>
  );
}

function DescarteItem({ descarte }: { descarte: DescarteZip }) {
  return (
    <div className="rounded-md border border-border bg-muted px-3 py-2 text-xs">
      <Group gap={6} wrap="nowrap">
        <code className="rounded bg-background px-1 py-0.5 font-mono text-[11px]">{descarte.path}</code>
        <Text size="xs" fw={600}>
          · {descarte.motivo}
        </Text>
      </Group>
      {descarte.detalle && (
        <Text size="xs" c="dimmed" className="mt-0.5">
          {descarte.detalle}
        </Text>
      )}
    </div>
  );
}
